type TrashProps = {
  className: string;
  color?: string;
};

export default function Trash(props: TrashProps) {
  const color = props.color ?? "#757575";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 15 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.7368 2.56001V3.33334H13.7151L12.4837 18.4933C12.4837 18.8929 12.3278 19.2762 12.0502 19.5587C11.7726 19.8413 11.3961 20 11.0035 20H3.74643C3.35385 20 2.97735 19.8413 2.69975 19.5587C2.42215 19.2762 2.26619 18.8929 2.26619 18.4933L1.12655 3.33334H0.0523834V2.56001H4.13941V1.49334C4.14615 1.09235 4.30564 0.709699 4.58425 0.426116C4.86286 0.142533 5.23879 -0.0198073 5.63275 -0.0266633H9.20888C9.405 -0.0299399 9.59961 0.00871165 9.78012 0.0868011C9.96064 0.164891 10.123 0.280674 10.2568 0.426665C10.3973 0.564516 10.5081 0.730446 10.5825 0.914011C10.6569 1.09758 10.6932 1.29481 10.6891 1.49334V2.53333L14.7368 2.56001ZM11.7633 18.44L12.9422 3.33334H1.84702L3.01286 18.44C3.01286 18.9333 3.27485 19.1733 3.78572 19.1733H11.0035C11.5144 19.1733 11.7633 18.9333 11.7633 18.44ZM4.80748 5.00001L5.37076 17.56H4.65029L4.08701 5.00001H4.80748ZM5.58034 0.786671C5.48215 0.77063 5.38162 0.778522 5.28701 0.809702C5.1924 0.840882 5.10642 0.894458 5.0361 0.966033C4.96578 1.03761 4.91315 1.12515 4.88251 1.22144C4.85188 1.31774 4.84413 1.42007 4.85989 1.52001V2.56001H9.87694V1.49334C9.8927 1.39339 9.88495 1.29107 9.85432 1.19477C9.82369 1.09847 9.77105 1.01094 9.70073 0.939361C9.63041 0.867786 9.54443 0.814209 9.44982 0.783029C9.35521 0.751849 9.25468 0.743958 9.15649 0.759999L5.58034 0.786671ZM7.00819 17.56V5.00001H7.67625V17.56H7.00819ZM10.6367 5.00001L10.0734 17.56H9.36607L9.87694 5.00001H10.6367Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
